import { render, staticRenderFns } from "./update_email.vue?vue&type=template&id=265a02d4"
import script from "./update_email.vue?vue&type=script&lang=js"
export * from "./update_email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports